/**
 * Configuration for notification system behavior
 * Centralized configuration makes it easy to adjust behavior across the entire app
 *
 * Note: Text strings should use next-intl translations, not config constants
 */
export const NOTIFICATION_CONFIG = {
  /** Time in milliseconds to wait before auto-marking as read */
  AUTO_MARK_DELAY: 1500,

  /** Time in milliseconds for dropdown auto-mark delay */
  AUTO_MARK_DROPDOWN_DELAY: 1500,

  /** Threshold for Intersection Observer (0-1, where 1 = 100% visible) */
  AUTO_MARK_THRESHOLD: 0.5,

  /** Number of notifications to show in dropdown */
  DROPDOWN_NOTIFICATION_LIMIT: 5,

  /** Animation duration for transitions in milliseconds */
  TRANSITION_DURATION: 300,

  /** Whether auto-mark is enabled by default */
  AUTO_MARK_ENABLED: true
} as const;

/**
 * Type-safe configuration access
 */
export type NotificationConfig = typeof NOTIFICATION_CONFIG;
